import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { FORM_SUCCESS_MESSAGE } from '../views/settings/consts';

type Errors = Array<{ [key: string]: string }>;

Component.registerHooks(['validations']);
@Component({
  mixins: [validationMixin],

  metaInfo: () => ({
    title: 'Регистрационные данные',
  }),
})
export default class SettingsMixin extends Vue {
  @Prop({ type: Object, default: () => {} })
  readonly profile!: any; // оно и есть user

  @Prop({ type: String, default: '' })
  readonly text!: any;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly color!: boolean;

  @Prop({ type: Array, default: () => [] })
  readonly errorsProp!: Errors;

  user: any = {};

  get v() {
    return (this as any).$v.user;
  }

  get state() {
    return this.$store.state;
  }

  get correctUpdateProfile() {
    return this.text === FORM_SUCCESS_MESSAGE;
  }

  get errorsFromProp() {
    return [...this.errorsProp].filter(
      ({ attribute }) => this.profile[attribute] !== this.user[attribute],
    );
  }

  get errors() {
    return this.errorsFromProp.reduce((res, { attribute, msg }) => {
      res[attribute] = msg;
      return res;
    }, {});
  }

  @Watch('changed')
  isChangeUserData(value: boolean) {
    this.$emit('changed');
  }

  submit(): void {
    this.v.$touch();
    if (this.v.$invalid) {
      return;
    }
     Object.keys(this.user).map((key) => {
      if (typeof this.user[key] === 'number')
        this.user[key] = String(this.user[key])
    })
    this.$emit('submitUser', this.user);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/SettingsMixin.ts